<template>
    <div v-show="isVisible">
        <div class="pl-4 pt-3 pb-4">
            <h5>Change details {{ change_key }}</h5>
        </div>
        <v-row no-gutters>
            <v-col cols="12" >                         
                <v-data-table dense 
                    :headers="getHeaders()"
                    :items="data" 
                    item-key="hwzr_encrid"
                    :disable-pagination=true hide-default-footer
                    style="width: 100%;">
                    <template v-slot:item="hwzr">
                        <tr>
                            <td class="row-default">{{ $moment(hwzr.item.hwzr_dt).format("DD-MM-YYYY HH:mm") }}</td>
                            <td class="row-default">{{ hwzr.item.hwzr_oms }}</td>
                            <td class="row-default">{{ hwzr.item.hwzr_hwst_display }}</td>
                            <td class="row-default">{{ hwzr.item.gebr_naam }}</td>
                            <td class="row-default">
                                <v-btn x-small text icon v-on:click="openUpdHwzr(hwzr.item.hwzr_encrid)"><v-icon small>mdi-wrench</v-icon></v-btn>
                            </td>
                            <td class="row-default">
                                <span v-if="hwzr.item.can_delete">
                                    <v-btn x-small text icon v-on:click="rmHwzr(hwzr.item.hwzr_encrid)"><v-icon small>mdi-trash-can-outline</v-icon></v-btn>
                                </span>
                                <span v-else>
                                    <v-btn x-small text icon disabled><v-icon small></v-icon></v-btn>
                                </span>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <v-row dense>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn x-small text icon v-bind="attrs" v-on="on" v-on:click="openUpdHwzr('')" class="mr-5 mb-2 gridbutton">
                        <v-icon small>mdi-plus</v-icon>
                    </v-btn>
                </template>
                <span>Add new event for {{ change_key }} </span>
            </v-tooltip>
        </v-row>
        <addUpdHwzr ref="addUpdHwzr" @updateData="updateData" />
    </div>
</template>


<script>
import addUpdHwzr from '@/components/huov/howz/addUpdHwzr.vue';

export default {
    props: {
        isVisible: {
            type: Boolean,
            default: false
        },
        howzEncrid: {
            type: String,
            default: ''
        },
        change_key: {
            type: String,
            default: ''
        },
        data: {
            type: Array
        }
    },
    components: {
        addUpdHwzr
    },
    data() {
        return {
        }
    },
    methods: {
        getHeaders(){
            return [
                { text: "Date/time", sortable: false,  width: "18%"},
                { text: "Description", sortable: false, width: "50%"},
                { text: "Status", sortable: false, width: "20%"},
                { text: "User", sortable: false, width: "20%"},
                { sortable: false, align: "start", width: "5%"},
                { sortable: false, align: "start", width: "5%"},
            ];
        },
        openUpdHwzr(hwzr_encrid) {
            this.$refs.addUpdHwzr.open(this.howzEncrid, hwzr_encrid);
        },
        rmHwzr(hwzr_encrid){
            this.$axios.post("ares/json/ares/huov/howz/rmHwzr.p", {
                header: {
                    token: this.$session.get("ARES"),
                    clientSessionId: this.$session.id(),
                    request: "rmHwzr"
                },
                rmHwzr: {
                    hwzr_encrid: hwzr_encrid
                }
            }).then(res => {
                if (res.data.error) {
                    console.log(res.data.error);
                } else {
                    this.updateData();
                }
            });
        },
        updateData(){
           this.$emit('updateData', 'refresh');
        },
    }
}
</script>

<style scoped>
    .row-default {
        cursor: default;
        vertical-align: top;
        border-top: 5px solid transparent;    
        font-size: 14px !important;
    }
    .gridbutton{
        border: 1px solid rgba(169, 169, 169, 1) !important;
    }
    .v-data-table {
        width: 100% !important;
    }
</style>